var $79e6d900d6a4f82d$exports = {};
$79e6d900d6a4f82d$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "Nevybrat\xE9 polo\u017Eky: ".concat(args.item, ".");
  },
  "longPressToSelect": "Dlh\u0161\xEDm stla\u010Den\xEDm prejdite do re\u017Eimu v\xFDberu.",
  "select": "Vybra\u0165",
  "selectedAll": "V\u0161etky vybrat\xE9 polo\u017Eky.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "\u017Diadne vybrat\xE9 polo\u017Eky",
      one: function one() {
        return "".concat(formatter.number(args.count), " vybrat\xE1 polo\u017Eka");
      },
      other: function other() {
        return "Po\u010Det vybrat\xFDch polo\u017Eiek:".concat(formatter.number(args.count));
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "Vybrat\xE9 polo\u017Eky: ".concat(args.item, ".");
  }
};
export { $79e6d900d6a4f82d$exports as default };